var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _path17, _mask, _path18, _path19, _rect2, _path20, _path21, _path22, _path23, _rect3, _path24, _path25, _path26, _path27, _rect4, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _rect5, _path35, _ellipse, _g, _ellipse2, _g2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _circle, _circle2, _circle3, _circle4, _path36, _path37, _ellipse7, _ellipse8, _path38, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 190,
    viewBox: "0 0 204 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M193.832 151.804C188.046 143.256 181.324 133.103 183.243 122.19C186.498 111.073 194.425 101.746 200.266 92.0008C207.165 79.7341 201.908 75.6545 190.522 71.1577C186.609 69.7298 181.445 68.9417 177.625 67.2913C169.28 62.5905 170.003 54.6074 158.098 49.3317C150.579 45.1316 143.467 46.4111 135.669 48.8218C129.198 50.4722 122.123 51.2788 115.457 51.0749C96.3104 49.9159 76.8766 48.8682 57.6932 49.1463C48.718 49.3967 38.8342 49.4894 30.1836 52.1318C18.26 57.3612 8.72852 68.0702 7.6808 81.6627C6.68871 114.874 25.5013 121.337 21.1528 133.539C17.5646 145.546 14.2916 169.078 26.243 176.968C36.405 181.465 57.962 171.646 70.6088 171.692C82.9497 170.978 86.7048 173.853 97.0058 179.249C108.568 184.506 121.187 187.668 133.778 188.855C152.043 190.765 170.81 188.057 188.009 181.567C206.2 174.177 205.477 166.101 193.832 151.795V151.804Z",
    fill: "#1A1E23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2821 32.6717L71.2429 31.8674L71.1154 31.014L70.9584 30.3471L70.7917 29.8566L70.5367 29.2191L70.2424 28.66L69.7618 27.9145L69.2223 27.2279L68.6829 26.6787L68.1728 26.2373L67.6628 25.8646L67.0939 25.5114L66.4955 25.2074L65.9757 24.9916L65.4853 24.8248L64.7202 24.6287L64.1611 24.5404L63.6609 24.4914L63.092 24.4717L62.6996 24.4815L62.1209 24.5306L61.5815 24.6091L61.0616 24.7268L60.6398 24.8445L60.3162 24.9622L59.9631 25.0897L59.6198 25.2466L59.2961 25.4035L59.0018 25.5605L58.5899 25.8253L58.1779 26.1098L57.9327 26.3059L57.7463 26.4531L57.5109 26.6689L57.2265 26.2078L56.7949 25.5703L56.4418 25.1093L55.8925 24.4717L55.3334 23.9126L54.8136 23.432L54.382 23.0985L53.9406 22.7749L53.4306 22.4316L52.7832 22.049L52.2928 21.794L51.6258 21.4997L50.9392 21.2349L50.1643 20.9995L49.3894 20.823L48.6832 20.7053L48.1339 20.6464L47.467 20.5974L47.0256 20.5875L46.2311 20.617L45.6524 20.666L45.1031 20.7445L44.495 20.8524L43.7201 21.0486L43.1708 21.2153L42.5136 21.4605L41.9644 21.6959L41.4837 21.9313L41.062 22.1569L40.5715 22.4512L40.1596 22.7356L39.7672 23.0103L39.522 23.2064L39.3651 23.3339L39.1689 23.4909L38.9629 23.6674L38.7275 23.2555L38.1292 22.3237L37.5211 21.4899L36.9522 20.7837L36.4127 20.1854L35.8144 19.5675L35.2259 19.0182L34.4706 18.3708L34.0194 18.0177L33.4505 17.6058L32.9405 17.2625L32.4403 16.9486L31.9596 16.6641L31.4888 16.4091L30.7336 16.0364L30.1647 15.7814L29.6448 15.5754L29.0563 15.3498L28.2912 15.1046L27.6733 14.928L27.0456 14.7711L26.4374 14.6436L25.7802 14.5357L25.1525 14.4474L24.6032 14.3885L23.9853 14.3493L23.5243 14.3199H22.9652L22.3178 14.3297L21.7391 14.3591L21.1408 14.4082L20.5523 14.4768L19.9638 14.5651L19.3556 14.673L18.8064 14.7907L18.2473 14.928L17.6588 15.0948L17.0899 15.2811L16.6191 15.4479L15.8638 15.7421L15.2557 16.0168L14.7554 16.2522L14.2944 16.4974L13.6275 16.8701L13.2253 17.1153L12.6956 17.4586L12.2543 17.7725L11.7638 18.1354L11.244 18.5474L10.7732 18.9593L10.2239 19.4694L9.7825 19.9108L9.3215 20.4012L8.76241 21.0486L8.2916 21.6567L7.90907 22.1863L7.50692 22.7749L7.23228 23.2359L6.84975 23.9028L6.51626 24.5208L6.222 25.1485L5.94736 25.7959L5.72176 26.404L5.49617 27.0514L5.32942 27.6007L5.14306 28.3069L5.03516 28.7679L4.94689 29.1896L4.86842 29.6408L4.79976 30.0626L4.75072 30.4942L4.68206 31.1612L4.64282 31.7497V32.6717H6.67319H71.2821Z",
    fill: "#F2F4F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.282 18.9412L159.243 18.1369L159.115 17.2836L158.958 16.6166L158.792 16.1262L158.537 15.4886L158.242 14.9295L157.762 14.1841L157.222 13.4975L156.683 12.9482L156.173 12.5068L155.663 12.1341L155.094 11.781L154.496 11.4769L153.976 11.2611L153.485 11.0944L152.72 10.8982L152.161 10.8099L151.661 10.7609L151.092 10.7413L150.7 10.7511L150.121 10.8001L149.581 10.8786L149.062 10.9963L148.64 11.114L148.316 11.2317L147.963 11.3592L147.62 11.5161L147.296 11.6731L147.002 11.83L146.59 12.0948L146.178 12.3793L145.933 12.5755L145.746 12.7226L145.511 12.9384L145.226 12.4774L144.795 11.8398L144.442 11.3788L143.893 10.7413L143.333 10.1822L142.814 9.70156L142.382 9.36807L141.941 9.04439L141.431 8.70109L140.783 8.31856L140.293 8.06353L139.626 7.76928L138.939 7.50445L138.164 7.26904L137.389 7.09249L136.683 6.97478L136.134 6.91593L135.467 6.86689L135.026 6.85708L134.231 6.88651L133.652 6.93555L133.103 7.01402L132.495 7.12191L131.72 7.31808L131.171 7.48483L130.514 7.73004L129.964 7.96545L129.484 8.20085L129.062 8.42645L128.572 8.72071L128.16 9.00515L127.767 9.27979L127.522 9.47596L127.365 9.60347L127.169 9.76041L126.963 9.93697L126.728 9.52501L126.129 8.59319L125.521 7.75947L124.952 7.05325L124.413 6.45493L123.814 5.83699L123.226 5.28771L122.471 4.64035L122.019 4.28724L121.451 3.87528L120.94 3.53198L120.44 3.21811L119.96 2.93366L119.489 2.67864L118.734 2.30591L118.165 2.05089L117.645 1.84491L117.056 1.61931L116.291 1.3741L115.673 1.19755L115.046 1.04061L114.437 0.913099L113.78 0.805205L113.153 0.716928L112.603 0.658076L111.985 0.618842L111.524 0.589417H110.965L110.318 0.599225L109.739 0.628651L109.141 0.677693L108.552 0.746353L107.964 0.83463L107.356 0.942524L106.806 1.06023L106.247 1.19755L105.659 1.36429L105.09 1.55065L104.619 1.7174L103.864 2.01166L103.256 2.2863L102.755 2.5217L102.294 2.76692L101.627 3.13964L101.225 3.38485L100.696 3.72815L100.254 4.04203L99.7638 4.40494L99.244 4.8169L98.7732 5.22886L98.2239 5.73891L97.7825 6.18029L97.3215 6.67072L96.7624 7.31808L96.2916 7.92621L95.9091 8.45588L95.5069 9.04439L95.2323 9.50539L94.8497 10.1724L94.5163 10.7903L94.222 11.4181L93.9474 12.0654L93.7218 12.6736L93.4962 13.3209L93.3294 13.8702L93.1431 14.5764L93.0352 15.0374L92.9469 15.4592L92.8684 15.9104L92.7998 16.3321L92.7507 16.7637L92.6821 17.4307L92.6428 18.0192V18.9412H94.6732H159.282Z",
    fill: "#F2F4F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.401 50.6124L111.382 50.2255L111.321 49.8151L111.245 49.4942L111.165 49.2583L111.043 48.9516L110.901 48.6827L110.67 48.3241L110.41 47.9938L110.151 47.7296L109.906 47.5173L109.66 47.338L109.387 47.1682L109.099 47.0219L108.849 46.9181L108.613 46.8379L108.245 46.7435L107.976 46.7011L107.735 46.6775L107.462 46.668L107.273 46.6728L106.994 46.6963L106.735 46.7341L106.485 46.7907L106.282 46.8473L106.126 46.9039L105.956 46.9653L105.791 47.0408L105.636 47.1163L105.494 47.1918L105.296 47.3191L105.098 47.456L104.98 47.5503L104.89 47.6211L104.777 47.7249L104.64 47.5032L104.432 47.1965L104.263 46.9747L103.998 46.668L103.729 46.3991L103.479 46.1679L103.272 46.0075L103.059 45.8518L102.814 45.6867L102.503 45.5026L102.267 45.38L101.946 45.2384L101.616 45.111L101.243 44.9978L100.87 44.9129L100.531 44.8563L100.266 44.8279L99.9455 44.8044L99.7332 44.7996L99.351 44.8138L99.0726 44.8374L98.8084 44.8751L98.5159 44.927L98.1431 45.0214L97.8789 45.1016L97.5628 45.2196L97.2986 45.3328L97.0674 45.446L96.8645 45.5545L96.6286 45.6961L96.4304 45.8329L96.2417 45.965L96.1238 46.0594L96.0483 46.1207L95.9539 46.1962L95.8548 46.2811L95.7416 46.083L95.4538 45.6348L95.1613 45.2337L94.8876 44.894L94.6281 44.6062L94.3403 44.3089L94.0572 44.0447L93.6939 43.7333L93.4769 43.5635L93.2032 43.3653L92.9579 43.2002L92.7172 43.0492L92.4861 42.9124L92.2596 42.7897L91.8963 42.6104L91.6226 42.4877L91.3726 42.3887L91.0895 42.2801L90.7215 42.1622L90.4242 42.0773L90.1222 42.0018L89.8297 41.9404L89.5136 41.8885L89.2116 41.8461L88.9474 41.8178L88.6502 41.7989L88.4284 41.7847H88.1595L87.8481 41.7894L87.5697 41.8036L87.2819 41.8272L86.9988 41.8602L86.7157 41.9027L86.4232 41.9546L86.159 42.0112L85.89 42.0773L85.607 42.1575L85.3333 42.2471L85.1068 42.3273L84.7435 42.4689L84.451 42.601L84.2104 42.7142L83.9886 42.8322L83.6678 43.0115L83.4743 43.1294L83.2196 43.2945L83.0072 43.4455L82.7713 43.6201L82.5213 43.8183L82.2948 44.0164L82.0306 44.2618L81.8183 44.4741L81.5965 44.71L81.3276 45.0214L81.1011 45.3139L80.9171 45.5687L80.7237 45.8518L80.5915 46.0735L80.4075 46.3944L80.2471 46.6916L80.1056 46.9936L79.9735 47.305L79.8649 47.5975L79.7564 47.9089L79.6762 48.1731L79.5866 48.5128L79.5347 48.7346L79.4922 48.9375L79.4545 49.1545L79.4214 49.3574L79.3978 49.565L79.3648 49.8858L79.3459 50.1689V50.6124H80.3226H111.401Z",
    fill: "#F2F4F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.698 35.9015L193.679 35.5146L193.618 35.1041L193.542 34.7833L193.462 34.5474L193.339 34.2407L193.198 33.9718L192.967 33.6132L192.707 33.2829L192.448 33.0187L192.202 32.8064L191.957 32.6271L191.683 32.4572L191.396 32.311L191.146 32.2072L190.91 32.127L190.542 32.0326L190.273 31.9901L190.032 31.9665L189.758 31.9571L189.57 31.9618L189.291 31.9854L189.032 32.0232L188.782 32.0798L188.579 32.1364L188.423 32.193L188.253 32.2543L188.088 32.3298L187.932 32.4053L187.791 32.4808L187.593 32.6082L187.395 32.745L187.277 32.8394L187.187 32.9102L187.074 33.014L186.937 32.7922L186.729 32.4855L186.559 32.2638L186.295 31.9571L186.026 31.6882L185.776 31.457L185.569 31.2966L185.356 31.1409L185.111 30.9757L184.8 30.7917L184.564 30.669L184.243 30.5275L183.913 30.4001L183.54 30.2869L183.167 30.2019L182.827 30.1453L182.563 30.117L182.242 30.0934L182.03 30.0887L181.648 30.1029L181.369 30.1264L181.105 30.1642L180.813 30.2161L180.44 30.3105L180.176 30.3907L179.86 30.5086L179.595 30.6219L179.364 30.7351L179.161 30.8436L178.925 30.9852L178.727 31.122L178.539 31.2541L178.421 31.3485L178.345 31.4098L178.251 31.4853L178.152 31.5702L178.038 31.372L177.751 30.9238L177.458 30.5228L177.184 30.1831L176.925 29.8953L176.637 29.598L176.354 29.3338L175.991 29.0224L175.774 28.8525L175.5 28.6544L175.255 28.4892L175.014 28.3383L174.783 28.2014L174.556 28.0788L174.193 27.8995L173.92 27.7768L173.669 27.6777L173.386 27.5692L173.018 27.4512L172.721 27.3663L172.419 27.2908L172.127 27.2295L171.81 27.1776L171.509 27.1351L171.244 27.1068L170.947 27.0879L170.725 27.0738H170.456L170.145 27.0785L169.867 27.0927L169.579 27.1163L169.296 27.1493L169.013 27.1917L168.72 27.2436L168.456 27.3003L168.187 27.3663L167.904 27.4465L167.63 27.5362L167.404 27.6164L167.04 27.7579L166.748 27.89L166.507 28.0033L166.286 28.1212L165.965 28.3005L165.771 28.4185L165.516 28.5836L165.304 28.7346L165.068 28.9092L164.818 29.1073L164.592 29.3055L164.327 29.5508L164.115 29.7631L163.893 29.9991L163.624 30.3105L163.398 30.603L163.214 30.8578L163.021 31.1409L162.888 31.3626L162.704 31.6834L162.544 31.9807L162.402 32.2827L162.27 32.5941L162.162 32.8866L162.053 33.198L161.973 33.4622L161.883 33.8019L161.832 34.0237L161.789 34.2265L161.751 34.4436L161.718 34.6465L161.695 34.8541L161.662 35.1749L161.643 35.458V35.9015H162.619H193.698Z",
    fill: "#F2F4F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.606 42.5894L173.626 49.4261L167.643 50.6505L173.986 52.0179L175.587 58.2831L176.587 51.7118L182.29 50.4261L176.427 49.4873L174.606 42.5894Z",
    fill: "#F2F4F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3564 42.5894L10.3759 49.4261L4.39282 50.6505L10.736 52.0179L12.3369 58.2831L13.3374 51.7118L19.0403 50.4261L13.1773 49.4873L11.3564 42.5894Z",
    fill: "#F2F4F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6064 133.589L10.6259 140.426L4.64282 141.651L10.986 143.018L12.5869 149.283L13.5874 142.712L19.2903 141.426L13.4273 140.487L11.6064 133.589Z",
    fill: "#F2F4F7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.606 117.589L188.626 124.426L182.643 125.651L188.986 127.018L190.587 133.283L191.587 126.712L197.29 125.426L191.427 124.487L189.606 117.589Z",
    fill: "#F2F4F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1246 117.589L25.6343 121.008L22.6428 121.62L25.8144 122.304L26.6148 125.436L27.1151 122.151L29.9665 121.508L27.0351 121.038L26.1246 117.589Z",
    fill: "#E2E5EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1246 86.5894L21.6343 90.0077L18.6428 90.62L21.8144 91.3036L22.6148 94.4363L23.1151 91.1506L25.9665 90.5077L23.0351 90.0384L22.1246 86.5894Z",
    fill: "#E2E5EC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M174.125 98.5894L173.634 102.008L170.643 102.62L173.814 103.304L174.615 106.436L175.115 103.151L177.967 102.508L175.035 102.038L174.125 98.5894Z",
    fill: "#E2E5EC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M189.8 78.3004L189.31 81.7187L186.319 82.3309L189.49 83.0146L190.291 86.1472L190.791 82.8615L193.642 82.2187L190.711 81.7493L189.8 78.3004Z",
    fill: "#E2E5EC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6428 162.589H173.643",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.143 162.589H193.143",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64282 162.589H17.6428",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.4983,
    y: 77.2964,
    width: 61.8667,
    height: 85.3414,
    rx: 4,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M136.234 78.0816H75.2678V83.5725H136.234V78.0816Z",
    fill: "#1A1E23"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-outside-1_256_8190",
    maskUnits: "userSpaceOnUse",
    x: 87.9631,
    y: 70.5894,
    width: 35,
    height: 15,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 87.9631,
    y: 70.5894,
    width: 35,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9631 76.5894C89.9631 74.3803 91.754 72.5894 93.9631 72.5894H116.896C119.106 72.5894 120.896 74.3803 120.896 76.5894V78.9005C120.896 81.1097 119.106 82.9005 116.896 82.9005H93.9631C91.754 82.9005 89.9631 81.1097 89.9631 78.9005V76.5894Z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9631 76.5894C89.9631 74.3803 91.754 72.5894 93.9631 72.5894H116.896C119.106 72.5894 120.896 74.3803 120.896 76.5894V78.9005C120.896 81.1097 119.106 82.9005 116.896 82.9005H93.9631C91.754 82.9005 89.9631 81.1097 89.9631 78.9005V76.5894Z",
    fill: "#9C82FA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9631 74.5894H116.896V70.5894H93.9631V74.5894ZM118.896 76.5894V78.9005H122.896V76.5894H118.896ZM116.896 80.9005H93.9631V84.9005H116.896V80.9005ZM91.9631 78.9005V76.5894H87.9631V78.9005H91.9631ZM93.9631 80.9005C92.8586 80.9005 91.9631 80.0051 91.9631 78.9005H87.9631C87.9631 82.2142 90.6494 84.9005 93.9631 84.9005V80.9005ZM118.896 78.9005C118.896 80.0051 118.001 80.9005 116.896 80.9005V84.9005C120.21 84.9005 122.896 82.2142 122.896 78.9005H118.896ZM116.896 74.5894C118.001 74.5894 118.896 75.4848 118.896 76.5894H122.896C122.896 73.2757 120.21 70.5894 116.896 70.5894V74.5894ZM93.9631 70.5894C90.6494 70.5894 87.9631 73.2757 87.9631 76.5894H91.9631C91.9631 75.4848 92.8586 74.5894 93.9631 74.5894V70.5894Z",
    fill: "#1A1E23",
    mask: "url(#path-19-outside-1_256_8190)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6545,
    y: 92.4918,
    width: 12.0296,
    height: 12.0296,
    rx: 4,
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M83.092 98.3353L84.8965 100.14L88.2476 96.7886",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5569 93.3511L131.209 93.3511",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5569 98.5074H114.883",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5569 103.664H114.883",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6545,
    y: 115.836,
    width: 12.0296,
    height: 12.0296,
    rx: 4,
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M83.092 121.679L84.8965 123.483L88.2476 120.132",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5569 116.695L131.209 116.695",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5569 121.851H114.883",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5569 127.007H114.883",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6545,
    y: 140.175,
    width: 12.0296,
    height: 12.0296,
    rx: 4,
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M83.092 146.019L84.8965 147.823L88.2476 144.472",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5569 141.035H131.209",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5569 146.191H114.883",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5569 151.347H114.883",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M90.6428 93.5894H80.6428V96.5894H90.6428V93.5894Z",
    fill: "#1A1E23"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M90.6428 116.589H80.6428V119.589H90.6428V116.589Z",
    fill: "#1A1E23"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M90.6428 140.589H80.6428V143.589H90.6428V140.589Z",
    fill: "#1A1E23"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 93.4006,
    y: 75.1675,
    width: 24.0593,
    height: 5.15556,
    rx: 2.57778,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M116.706 76.0269H94.1506V77.7454H116.706V76.0269Z",
    fill: "#1A1E23"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4447,
    cy: 136.589,
    rx: 26.8019,
    ry: 26,
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4443 115.554C66.3649 115.554 76.9207 121.546 77.8804 129.161C77.9146 128.713 77.9489 128.284 77.9489 127.817C77.9489 118.298 66.9818 110.589 53.4443 110.589C39.9068 110.589 28.9397 118.317 28.9397 127.817C28.9397 128.265 28.9397 128.713 29.0083 129.161C29.9679 121.546 40.558 115.554 53.4443 115.554Z",
    fill: "#1A1E23"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4436,
    cy: 136.588,
    rx: 20.6758,
    ry: 20.0571,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4474 121.496C63.9453 121.496 72.522 127.487 73.3016 135.102C73.3295 134.654 73.3573 134.225 73.3573 133.758C73.3573 124.239 64.4466 116.531 53.4474 116.531C42.4481 116.531 33.5374 124.258 33.5374 133.758C33.5374 134.206 33.5374 134.654 33.5931 135.102C34.3727 127.487 42.9772 121.496 53.4474 121.496Z",
    fill: "#1A1E23"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4441,
    cy: 120.247,
    rx: 1.53173,
    ry: 1.48571,
    fill: "#1A1E23"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4441,
    cy: 153.677,
    rx: 1.53173,
    ry: 1.48571,
    fill: "#1A1E23"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.6736,
    cy: 136.962,
    rx: 1.48571,
    ry: 1.53173,
    transform: "rotate(90 70.6736 136.962)",
    fill: "#1A1E23"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.2166,
    cy: 136.962,
    rx: 1.48571,
    ry: 1.53173,
    transform: "rotate(90 36.2166 136.962)",
    fill: "#1A1E23"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.50889,
    cy: 1.50889,
    r: 1.50889,
    transform: "matrix(-0.717763 0.696287 -0.717763 -0.696287 67.7952 148.781)",
    fill: "#1A1E23"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.50889,
    cy: 1.50889,
    r: 1.50889,
    transform: "matrix(-0.717763 0.696287 -0.717763 -0.696287 43.428 125.144)",
    fill: "#1A1E23"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.50889,
    cy: 1.50889,
    r: 1.50889,
    transform: "matrix(-0.717763 -0.696287 0.717763 -0.696287 41.26 150.882)",
    fill: "#1A1E23"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.50889,
    cy: 1.50889,
    r: 1.50889,
    transform: "matrix(-0.717763 -0.696287 0.717763 -0.696287 65.6272 127.242)",
    fill: "#1A1E23"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4436 137.331L53.4436 124.703",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4417 137.331L61.0999 129.902",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4426,
    cy: 136.588,
    rx: 2.97143,
    ry: 3.06345,
    transform: "rotate(90 53.4426 136.588)",
    fill: "#1A1E23"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.4471,
    cy: 136.589,
    rx: 1.27347,
    ry: 1.31291,
    transform: "rotate(90 53.4471 136.589)",
    fill: "#9C82FA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M136.963 138.882C136.776 139.07 136.67 139.324 136.67 139.589C136.67 139.855 136.776 140.109 136.963 140.297L147.791 151.125C148.182 151.515 148.815 151.515 149.205 151.125L168.033 132.297C168.424 131.906 168.424 131.273 168.033 130.882L165.205 128.054C165.018 127.867 164.764 127.761 164.498 127.761C164.233 127.761 163.979 127.867 163.791 128.054L148.498 143.347L141.205 136.054C140.815 135.664 140.182 135.664 139.791 136.054L136.963 138.882ZM139.72 120.466C143.502 117.939 147.948 116.59 152.497 116.589C158.592 116.607 164.432 119.037 168.741 123.346C173.051 127.656 175.48 133.496 175.498 139.591C175.498 144.139 174.149 148.586 171.622 152.368C169.095 156.15 165.503 159.098 161.3 160.839C157.097 162.579 152.473 163.035 148.011 162.147C143.55 161.26 139.451 159.069 136.235 155.853C133.018 152.636 130.828 148.538 129.94 144.076C129.053 139.615 129.508 134.99 131.249 130.788C132.99 126.585 135.938 122.993 139.72 120.466Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.498 123.005C140.898 123.005 131.421 130.748 130.56 140.589C130.529 140.011 130.498 139.456 130.498 138.853C130.498 126.551 140.344 116.589 152.498 116.589C164.652 116.589 174.498 126.575 174.498 138.853C174.498 139.432 174.498 140.011 174.437 140.589C173.575 130.748 164.068 123.005 152.498 123.005Z",
    fill: "#1A1E23"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.b4bf63e23059d5fe73ebfe7313c912b6.svg";
export { ForwardRef as ReactComponent };